import type { JsRenderCodeCell } from '@/app/quadratic-core-types';

export type CodeTableClickTarget = 'data' | 'anchor' | 'table-name' | 'column-header' | 'single-cell';

export function getCodeTableClickTarget(codeCell: JsRenderCodeCell, column: number, row: number): CodeTableClickTarget {
  // A code cell that does not output a table (spill error, run error, or not yet
  // run) does not render its table UI, so it should behave like a single code
  // cell (double-click / Enter opens the full code editor so the user can edit
  // and fix the code).
  const hasNoTableOutput =
    !!codeCell.spill_error ||
    codeCell.state === 'RunError' ||
    codeCell.state === 'SpillError' ||
    codeCell.state === 'NotYetRun';
  const isSingleCell =
    hasNoTableOutput || (codeCell.w === 1 && codeCell.h === 1 && !codeCell.show_name && !codeCell.show_columns);
  if (isSingleCell) {
    return 'single-cell';
  }

  if (codeCell.show_name && row === codeCell.y) {
    return 'table-name';
  }

  if (codeCell.show_columns && row === codeCell.y + (codeCell.show_name ? 1 : 0)) {
    return 'column-header';
  }

  // When show_name is true the table-name check above already handles the top
  // row (which includes the anchor cell), so the table name takes precedence
  // over the anchor. This branch only applies when there is no name row.
  if (column === codeCell.x && row === codeCell.y) {
    return 'anchor';
  }

  return 'data';
}
